import React from "react";

const ProjectsSection = () => {
  const projects = [
    {
      id: 1,
      image: "https://themewagon.github.io/HighTechIT/img/project-1.jpg",
      title: "Web design",
      subtitle: "Web Analysis",
      delay: ".3s",
    },
    {
      id: 2,
      image: "https://themewagon.github.io/HighTechIT/img/project-2.jpg",
      title: "Cyber Security",
      subtitle: "Cyber Security Core",
      delay: ".5s",
    },
    {
      id: 3,
      image: "https://themewagon.github.io/HighTechIT/img/project-3.jpg",
      title: "Mobile Info",
      subtitle: "Upcomming Phone",
      delay: ".7s",
    },
    {
      id: 4,
      image: "https://themewagon.github.io/HighTechIT/img/project-4.jpg",
      title: "Web Development",
      subtitle: "Web Analysis",
      delay: ".3s",
    },
    {
      id: 5,
      image: "https://themewagon.github.io/HighTechIT/img/project-5.jpg",
      title: "Digital Marketing",
      subtitle: "Marketing Analysis",
      delay: ".5s",
    },
    {
      id: 6,
      image: "https://themewagon.github.io/HighTechIT/img/project-6.jpg",
      title: "Keyword Research",
      subtitle: "Keyword Analysis",
      delay: ".7s",
    },
  ];

  return (
    <div className="container-fluid project py-5 mb-5">
      <div className="container">
        <div
          className="text-center mx-auto pb-5 wow fadeIn"
          data-wow-delay=".3s"
          style={{
            maxWidth: "600px",
            visibility: "visible",
            animationDelay: "0.3s",
            animationName: "fadeIn",
          }}
        >
          <h5 className="text-primary">Our Project</h5>
          <h1>Our Recently Completed Projects</h1>
        </div>

        <div className="row g-5 m-1">
          {projects.map((project) => (
            <div
              key={project.id}
              className="col-md-6 col-lg-4 wow fadeIn"
              data-wow-delay={project.delay}
              style={{
                visibility: "visible",
                animationDelay: project.delay,
                animationName: "fadeIn",
              }}
            >
              <div className="project-item">
                <div className="project-img">
                  <img
                    src={project.image}
                    className="img-fluid w-100 rounded"
                    alt={project.title}
                  />
                  <div className="project-content">
                    <a href="#" className="text-center">
                      <h4 className="text-secondary">{project.title}</h4>
                      <p className="m-0 text-white">{project.subtitle}</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectsSection;
